

import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

@Component({
    components: {

    },
})
export default class ItemRightHeader extends Vue {
    @Prop({ type: String, default: null }) readonly columnSpan!: string;
    @Prop({ type: String, default: null }) readonly width!: string;
    

}
